/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundDividendRequestDto } from '../../models/backend-patched-venture-fund-dividend-request-dto';
import { BackendVentureFundDividendDto } from '../../models/backend-venture-fund-dividend-dto';

export interface VentureFundsVentureFundDividendsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedVentureFundDividendRequestDto;
}

export function ventureFundsVentureFundDividendsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundDividendsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundDividendsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDividendDto>;
    }),
  );
}

ventureFundsVentureFundDividendsPartialUpdate.PATH = '/api/venture_funds/venture-fund-dividends/{id}/';
